import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-sound-low-fill",
  "use": "rt-base-sound-low-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-sound-low-fill\"><path d=\"M573.7 205.9L435.5 351.4l-173-2.9-4.3 0.1c-33.8 2-60.2 30-60.2 63.9V626c0 35.3 28.7 64 64 64h171.3l140.3 128.1c30.2 31.8 84.1 10.6 84.1-33V238.9c0.1-43.6-53.8-64.8-84-33zM731.5 355.2L702 412.1c37.4 23.3 60.1 64.4 60 108.5 0.1 43.3-21.8 83.7-58.1 107.2l29.7 57c57.5-34.7 92.5-97 92.4-164.2 0.1-68-35.9-131-94.5-165.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/sound-low-fill.svg
// module id = 1752
// module chunks = 228